import send from '../../utils/fetch'

const state = {
    affiliate: {
        holds: [],
        total: []
    }
}

const actions = {
    async GET_AFFILIATE({ commit }) {
        try {
            const {data} = await send(global.$url.statistic.affiliate, 'GET')
            commit('SET_AFFILIATE', data.result)
            return data
        } catch (e) {}
    }
}

const mutations = {
    SET_AFFILIATE(state, data) {
        const {deposits, total} = data
        const {byGeo, byGeoAction, fromHold, holds, geos} = data
        const list = []
        let holdsList = []

        for (const totalKey in total) {
            const obj = {}
            obj.details = []
            obj.offer = totalKey
            obj.count = 0
            obj.countLeads = 0
            obj.countActions = 0

            for (const depositKey in deposits[totalKey]) {
                const dep = deposits[totalKey][depositKey][0]
                const tot = total[totalKey][depositKey][0]
                obj.countLeads += tot.leads
                obj.countActions += dep.action
                obj.details.push({...tot, ...dep, count: ((dep.action / tot.leads) * 100).toFixed(2) + '%'})
            }

            obj.count = ((obj.countActions / obj.countLeads) * 100).toFixed(2) + '%'
            list.push(obj)
        }

        const all = {
            geo: '',
            leads: 0,
            fromHold: 0,
            actions: 0,
            holds: 0
        }

        for (const geo of geos) {
            const obj = {
                geo: geo.name,
                leads: 0,
                fromHold: 0,
                actions: 0,
                holds: 0
            }

            all.geo = ''

            for (const byGeoActionKey in byGeoAction) {
                if (byGeoAction[byGeoActionKey][0].geo === geo.name) {
                    all.actions += byGeoAction[byGeoActionKey][0].actions
                    Object.assign(obj, byGeoAction[byGeoActionKey][0])
                    break
                }
            }

            for (const byGeoKey in byGeo) {
                if (byGeo[byGeoKey][0].geo === geo.name) {
                    all.leads += byGeo[byGeoKey][0].leads
                    Object.assign(obj, byGeo[byGeoKey][0])
                    break
                }
            }

            for (const fromHoldKey in fromHold) {
                if (fromHoldKey === geo.name) {
                    all.fromHold += fromHold[fromHoldKey].length
                    obj.fromHold = fromHold[fromHoldKey].length
                    break
                }
            }

            for (const holdsKey in holds) {
                if (holdsKey === geo.name) {
                    all.holds += holds[holdsKey].length
                    obj.holds = holds[holdsKey].length
                    break
                }
            }
            holdsList.push(obj)
        }

        holdsList.unshift(all)

        state.affiliate.holds = holdsList.filter(el => el.leads !== 0 || el.fromHold !== 0 || el.actions !== 0 || el.holds !== 0)
        state.affiliate.total = list
    }}

const getters = {
    affiliate: state => state.affiliate
}

export default {
    state,
    actions,
    mutations,
    getters
}
